import { Box, Typography, Paper, Button, IconButton, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import FilterListIcon from '@mui/icons-material/FilterList';
import { LocalPolice, Search } from '@mui/icons-material';

import { ColumnTitle, Pagination, ScrollbarCustom, WrapTable } from '../../../../components';
import { useGetList } from '../../../../services/charge-sessions/useChargeSession';
import { useState } from 'react';
import { IUserDetail } from '../../../../types/User';
import { convertToDateTime } from '../../../../utils/datetime';
import { formatPrice } from '../../../../utils/format';
import Copyable from '../../../../components/Copyable';

export const IdlingPenalty = ({ userDetail }: { userDetail: IUserDetail }) => {
    const [page, setPage] = useState(1);
    const { data, isFetching } = useGetList(page, {
        user_id: userDetail._id,
        by_type: "historical_idling_sessions",
        per_page: 10,
    });

    return (
        <Box sx={{ color: 'white', p: 4 }}>
            <Stack direction="row" alignItems="center" mb={4} spacing={2}>
                <Box sx={{ mr: 2, display: 'flex', alignItems: 'center' }}>
                    <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', fontSize: 32, mr: 1 }}>
                        <LocalPolice style={{ fill: '#FB9347', width: 32, height: 32 }} />
                    </Box>
                    <Box>
                        <Typography variant="h5" fontWeight={600}>Idling Penalty</Typography>
                        <Typography variant="body2" color="gray">Get a detailed breakdown of user idling penalties.</Typography>
                    </Box>
                </Box>
                <Box sx={{ flexGrow: 1 }} />
                <Stack direction="row" spacing={1}>
                    <Button variant="outlined" startIcon={<Search />} sx={{ borderRadius: 5, color: 'white', borderColor: '#0D0D0D', bgcolor: '#0D0D0D', '&:hover': { bgcolor: '#333', borderColor: '#666' } }}>
                        Search
                    </Button>
                    <Button variant="outlined" startIcon={<DownloadIcon />} sx={{ borderRadius: 5, color: 'white', borderColor: '#0D0D0D', bgcolor: '#0D0D0D', '&:hover': { bgcolor: '#333', borderColor: '#666' } }}>
                        Download CSV
                    </Button>
                    <IconButton sx={{ borderRadius: 3, color: 'white', border: '1px solid #444', bgcolor: '#0D0D0D', '&:hover': { bgcolor: '#333', borderColor: '#666' } }}>
                        <FilterListIcon />
                    </IconButton>
                </Stack>
            </Stack>
            <Paper elevation={0} sx={{ bgcolor: '#191919', borderRadius: 4, p: 4 }}>
                <Box mb={2}>
                    <WrapTable isLoading={isFetching} height="100%">
                        <TableContainer>
                            <ScrollbarCustom autoHide>
                                <Table sx={{ minWidth: 650 }}>
                                    <TableHead>
                                        <TableRow>
                                            <ColumnTitle sx={{ minWidth: 50 }} align="center">
                                                SN
                                            </ColumnTitle>
                                            <ColumnTitle>Charging session ID</ColumnTitle>
                                            <ColumnTitle>Charger name</ColumnTitle>
                                            <ColumnTitle>End charging time</ColumnTitle>
                                            <ColumnTitle>Unplug time</ColumnTitle>
                                            <ColumnTitle>Idling Duration</ColumnTitle>
                                            <ColumnTitle>Idling Amount (wGST)</ColumnTitle>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {data?.data.map((row: any, index: number) => (
                                            <TableRow key={index}>
                                                <TableCell align="center">
                                                    {page * 10 - 10 + index + 1}
                                                </TableCell>
                                                <TableCell><Copyable text={row.ampeco_session_id} /></TableCell>
                                                <TableCell>{row.Evse?.name}</TableCell>
                                                <TableCell>
                                                    {row.session_stopped_at
                                                        ? convertToDateTime(row.session_stopped_at)
                                                        : row.session_ended_at
                                                            ? convertToDateTime(row.session_ended_at)
                                                            : "-"}
                                                </TableCell>
                                                <TableCell>
                                                    {convertToDateTime(row.unplugged_at)}
                                                </TableCell>
                                                <TableCell>
                                                    {row.idling_time ? row.idling_time : "-"}
                                                </TableCell>
                                                <TableCell>
                                                    {row.idling_fee_with_gst
                                                        ? formatPrice(row.idling_fee_with_gst)
                                                        : "-"}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </ScrollbarCustom>
                        </TableContainer>
                    </WrapTable>
                    <Pagination
                        page={page}
                        setPage={setPage}
                        totalItems={data?.total || 0}
                        totalPage={Math.ceil((data?.total || 0) / 10)}
                        currentPage={page}
                    />
                </Box>
            </Paper>
        </Box>
    );
}
